"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Direction;
(function (Direction) {
    Direction["DownLeft"] = "down-left";
    Direction["DownRight"] = "down-right";
    Direction["UpLeft"] = "up-left";
    Direction["UpRight"] = "up-right";
})(Direction || (Direction = {}));
exports.default = Direction;
